import React from 'react';
import {
    VerifiedTick,
    ProBadge
} from '$partials/icons/index.js';
import Image from '$partials/media/image';
import { Button } from '$partials/ui';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */


/**
 * @type {import('$types/components/partials/modules.d.ts').ModuleTicker}
 */

const ModuleTicker = ({
    items,
    heading
}) => {
    items = items?.items;
    if (!items.length) {
        return null;
    }

    // Duplicate messages to fill screen
    let displayedLogo = items;
    while (displayedLogo.length < 4) {
        displayedLogo = displayedLogo.concat(items);
    }

    // Duplicate messages to handle overflow repeats
    const duplicateCount = 4;
    let duplicatedLogos = [];
    for (let i = 0; i < duplicateCount; i++) {
        duplicatedLogos = duplicatedLogos.concat(displayedLogo);
    }

    const animationDuration = (duplicatedLogos.length / duplicateCount) * 15;

    return (
        <section className='bg-white overflow-hidden relative py-24 md:py-40'>
            <div className='overflow-hidden layout-container layout-site-outer-padding ticker-fade'>
                <div className={'bg-white w-screen max-w-screen left-1/2 relative -translate-x-1/2 leading-[0]'}>
                    {heading && (
                        <div className=''>
                            <h3 className='type-style-eyebrow text-text-primary text-center'>{heading}</h3>
                        </div>
                    )}
                    <Ticker
                        className='ticker mt-32'
                        items={duplicatedLogos}
                        style={{
                            animationDuration: `${animationDuration}s`
                        }}/>
                </div>
            </div>
        </section>
    );
};


const Ticker = (props) => {
    return (
        <ul
            className={props.className}
            style={props.style}>
            {props.items?.map((item, i) => {
                if (!item) { return null; }

                let content;
                if (item?.__typename === 'BvaAvatar') {
                    if (item?.link) {
                        content = (
                            <Button
                                as='a'
                                className='flex flex-col items-center gap-16 group'
                                href={item.link}>
                                {item?.avatarImage && (
                                    <div className='relative'>
                                        <Image
                                            className='object-cover h-full w-full'
                                            containerClassName='rounded-full h-[120px] w-[120px] overflow-clip relative'
                                            loading={item?.avatarImage?.loading}
                                            src={item?.avatarImage?.src}/>
                                        <div
                                            className='absolute inset-0 h-[120px] w-[120px] rounded-full opacity-0 group-hover:opacity-100 transition-opacity'
                                            style={{ background: 'rgba(0, 0, 0, 0.15)' }} />
                                        {item?.verified && (
                                            <div className='absolute top-0 -right-5'>
                                                <VerifiedTick className='w-48 h-48'/>
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div className='flex flex-col gap-y-3 text-center'>
                                    <span className='type-style-body text-text-primary group-hover:text-brand-500 transition-colors'>
                                        {item?.name}
                                        {item?.pro && <ProBadge className='inline-block ml-8 w-24'/>}
                                    </span>
                                    <span className='type-style-body text-text-tertiary'>{item?.role}</span>
                                </div>
                            </Button>
                        );
                    } else {
                        content = (
                            <div className='flex flex-col items-center gap-16'>
                                {item?.avatarImage && (
                                    <div className='relative'>
                                        <Image
                                            className='object-cover h-full w-full'
                                            containerClassName='rounded-full h-[120px] w-[120px] overflow-clip relative'
                                            loading={item?.avatarImage?.loading}
                                            src={item?.avatarImage?.src}/>
                                        {item?.verified && (
                                            <div className='absolute top-0 -right-5'>
                                                <VerifiedTick className='w-48 h-48'/>
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div className='flex flex-col gap-y-3 text-center'>
                                    <span className='type-style-body text-text-primary'>
                                        {item?.name}
                                        {item?.pro && <ProBadge className='inline-block ml-8 w-24'/>}
                                    </span>
                                    <span className='type-style-body text-text-tertiary'>{item?.role}</span>
                                </div>
                            </div>
                        );
                    }
                } else {
                    content = (
                        <Image
                            className='object-contain h-full w-full'
                            containerClassName='size-70'
                            src={item?.image?.src}/>
                    );
                }

                return (
                    <li
                        className={'inline-block mr-40 md:mr-80 px-24 md:px-16 bg-sand rounded-xl'}
                        key={i}>
                        {content}
                    </li>
                );
            })}
        </ul>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default ModuleTicker;
